import { useNotify, useTranslate } from 'ra-core';
import { authProvider } from '@/authProvider.ts';
import { Notification } from '@/components/admin';
import { Button } from '@/components/ui/button.tsx';

export const EmailVerificationSent = ({ email }: { email: string }) => {
  const notify = useNotify();
  const t = useTranslate();

  const handleResendEmail = async () => {
    try {
      await authProvider.sendEmailVerification();
      notify('auth.success.email_sent');
    } catch (error: any) {
      console.error('send verification email failed', error);
      notify('auth.error.verification_email');
    }
  };

  return (
    <>
      <Notification />
      <img
        alt="logo"
        src="https://storage.googleapis.com/public-goloot-production/goloot/goloot-logo-white.png"
        style={{ width: 100, height: 'auto' }}
        className="mx-auto"
      />
      <div className="flex flex-col gap-4 text-center">
        <h1 className="text-2xl font-bold">{t('auth.message.verify')}</h1>
        <p className="mb-8">
          {t('auth.message.verification_sent')} {email}
          {'.'}
        </p>
        <p className="text-muted-foreground">
          {t('auth.message.email_not_received.line1')}
          <br />
          {t('auth.message.email_not_received.line2')}
          <Button variant="link" onClick={handleResendEmail}>
            {t('auth.button.resend_verification')}
          </Button>
        </p>
      </div>
    </>
  );
};
